<template>
  <div class="fotoportada-container" ref="containerRef">
    <!-- Capa de oscurecimiento concentrada exclusivamente debajo de las letras -->
    <div ref="darkOverlayRef" class="dark-overlay"></div>

    <!-- Contenedor editable de posición -->
    <div class="overlay-content">
      <!-- 1. MIS XV Y ADORNO -->
      <div ref="misXvWrapperRef" class="mis-xv-wrapper">
        <span class="subtitulo-editorial"></span>
        <div ref="misXvTopRef" class="mis-xv-top">
          MIS XV
        </div>
      </div>

      <!-- 2. NOMBRE Y APELLIDO -->
      <div ref="nombreContainerRef" class="centered-text">
        <span ref="nombrePrincipalRef" class="nombre-principal">Kitzya Renatta</span>
        <span ref="apellidoRef" class="nombre-apellido"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CoverComponent',
  setup() {
    const containerRef = ref(null)
    const nombreContainerRef = ref(null)
    const nombrePrincipalRef = ref(null)
    const apellidoRef = ref(null)
    const misXvWrapperRef = ref(null)
    const misXvTopRef = ref(null)
    const darkOverlayRef = ref(null)
    let tl = null

    onMounted(async () => {
      await nextTick()

      gsap.config({ force3D: true })

      tl = gsap.timeline({
        defaults: { ease: 'power2.out' }
      })

      tl.fromTo(
        containerRef.value,
        { autoAlpha: 0, scale: 1.12 },
        { autoAlpha: 1, scale: 1, duration: 1.8, ease: 'power1.out' }
      )
      .fromTo(
        darkOverlayRef.value,
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 1.2, ease: 'sine.out' },
        '-=1.4'
      )
      .fromTo(
        misXvWrapperRef.value,
        { autoAlpha: 0, y: 20, scale: 0.9 },
        { autoAlpha: 1, y: 0, scale: 1, duration: 1.0 },
        '-=0.9'
      )
      .fromTo(
        nombrePrincipalRef.value,
        { autoAlpha: 0, y: 15 },
        { autoAlpha: 1, y: 0, duration: 1.0 },
        '-=0.6'
      )
      .fromTo(
        apellidoRef.value,
        { autoAlpha: 0, y: 10 },
        { autoAlpha: 1, y: 0, duration: 0.8 },
        '-=0.7'
      )
    })

    onUnmounted(() => {
      if (tl) tl.kill()
    })

    return {
      containerRef,
      nombreContainerRef,
      nombrePrincipalRef,
      apellidoRef,
      misXvWrapperRef,
      misXvTopRef,
      darkOverlayRef
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&family=Cormorant+Garamond:ital,wght@0,300;1,300&family=Pinyon+Script&display=swap');

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 95vh;
  overflow: hidden;
  background-image: url('@/assets/DSC_5051 (2)_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: 1;
  will-change: transform, opacity;
  transform: translateZ(0);
}

/* GRADIENTE INFERIOR: Oscurece solo de la parte baja hacia arriba */
.dark-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 55%; /* Ocupa un poco más de la mitad inferior para cubrir el texto */
  pointer-events: none;
  background: linear-gradient(
    to top,
    rgba(10, 8, 15, 0.92) 0%,
    rgba(10, 8, 15, 0.65) 45%,
    rgba(10, 8, 15, 0.15) 80%,
    transparent 100%
  );
  z-index: 2;
  will-change: opacity;
}

/* =========================================================================
   CONTENEDOR DE POSICIÓN LIBRE Y EDITABLE
   ========================================================================= */
.overlay-content {
  position: absolute;
  z-index: 3;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  gap: 12px;
  text-align: center;

  /* --- MUEVE EL TEXTO A TU CONVENIENCIA AQUÍ --- */
  top: 70%; 
  left: 50%;
  transform: translate(-50%, -50%);
}

/* 1. MIS XV */
.mis-xv-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.subtitulo-editorial {
  font-family: 'Cinzel', serif;
  font-size: 10px;
  letter-spacing: 4px;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
}

.mis-xv-top {
  font-family: 'Cinzel', serif;
  font-size: 18px;
  letter-spacing: 6px;
  color: #f3e5ab;
  text-transform: uppercase;
  text-shadow: 0 0 10px rgba(243, 229, 171, 0.4);
}

/* 2. NOMBRE PRINCIPAL Y APELLIDO */
.centered-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  /* Sombra más marcada para contraste extremo sobre la sombra inferior */
  text-shadow: 
    0 3px 12px rgba(0, 0, 0, 0.95),
    0 0 20px rgba(0, 0, 0, 0.8),
    0 0 25px rgba(212, 175, 55, 0.35);
  margin: 0;
  padding: 0;
  will-change: transform, opacity;
}

.nombre-principal {
  font-family: 'CynthiaJuneJF', 'Pinyon Script', cursive, serif;
  font-size: 63px;
  line-height: 1.05;
  display: block;
  white-space: nowrap;
}

.nombre-apellido {
  font-family: 'CynthiaJuneJF', 'Pinyon Script', cursive, serif;
  font-size: 45px;
  line-height: 1.0;
  margin-top: -10px;
  display: block;
  white-space: nowrap;
}

/* Evita FOUC antes de iniciar la línea de tiempo de GSAP */
.fotoportada-container,
.dark-overlay,
.mis-xv-wrapper,
.nombre-principal,
.nombre-apellido {
  opacity: 0;
}
</style>